<template>
  <svg class="emd-pagarme-loader" :class="classList" width="120px" height="28px" viewBox="0 0 120 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M116.491189,4.94713287 C109.929637,-1.51161046 99.3998737,-1.51161046 92.8383217,4.94713287 C88.2361669,9.49960109 82.0193846,12.0457465 75.546014,12.0295309 C69.0712049,12.0459565 62.8530174,9.4991676 58.2500699,4.94545455 C51.6847517,-1.51287809 41.1530861,-1.51225557 34.5885315,4.94685315 C29.9859542,9.4990649 23.7688741,12.0448065 17.2953846,12.027972 C10.821155,12.0442506 4.60350539,9.49806125 0.00027972028,4.94545455" fill="none" stroke-width="3"></path>
  </svg>
</template>

<script>
export default {
  name: 'EmdPagarmeLoader',
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary', 'success', 'danger', 'info', 'warning', 'subtle'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      return classList
    }
  }
}
</script>
